module.exports = __webpack_public_path__ + "img/tick.c1c507e7.svg";